export function GoldDivider({ className = "" }) {
  return <div className={`gold-hairline w-full ${className}`} />;
}

export function Overline({ children }) {
  return (
    <p className="text-xs tracking-luxe uppercase font-semibold text-gold">
      {children}
    </p>
  );
}

// Fleur-de-lis ornament divider (transparent gold asset)
export function OrnamentDivider({ className = "", width = 220 }) {
  return (
    <div className={`flex justify-center ${className}`}>
      <img
        src="/gold-divider.png"
        alt=""
        aria-hidden="true"
        style={{ width, maxWidth: "80%" }}
        className="h-auto opacity-90 select-none pointer-events-none"
      />
    </div>
  );
}

// Gold filigree corner flourishes framing a section. Place inside a relative parent.
export function CornerOrnaments({ size = 130, opacity = 0.55 }) {
  const base = "absolute pointer-events-none select-none hidden md:block";
  return (
    <>
      <img src="/gold-corner.png" alt="" aria-hidden="true" style={{ width: size, opacity }}
        className={`${base} top-4 left-4`} />
      <img src="/gold-corner.png" alt="" aria-hidden="true" style={{ width: size, opacity }}
        className={`${base} top-4 right-4 scale-x-[-1]`} />
      <img src="/gold-corner.png" alt="" aria-hidden="true" style={{ width: size, opacity }}
        className={`${base} bottom-4 left-4 scale-y-[-1]`} />
      <img src="/gold-corner.png" alt="" aria-hidden="true" style={{ width: size, opacity }}
        className={`${base} bottom-4 right-4 scale-[-1]`} />
    </>
  );
}
